export const size = {
    large: 1140,
}

export const breakpoints = {
    small: `@media only screen and (max-width: ${size.large}px)`,
    large: `@media only screen and (min-width: ${size.large}px)`,
};